"use client"

import { useEffect } from 'react'
import type { Locale } from '@/app/[lang]/dictionaries'

export function SetLocaleAttr({ locale }: { locale: Locale }) {
  useEffect(() => {
    document.documentElement.lang = locale
  }, [locale])
  return null
}
